import Box from "@mui/material/Box";
import React from "react";

const ToolbarSeparator = () => {
	return (
		<Box
			bgcolor="grey.400"
			height={20}
			width="1px"
		/>
	);
};

export default ToolbarSeparator;
